import React from 'react';
import {ConfigProvider, Select} from "antd";
import 'antd/lib/select/style/css';
import getConfiguration from '../../../actions/getConfiguration';
import setConfigurationParam from '../../../actions/setConfigurationParam';
import modalShow from '../../../actions/modalShow';
import modalDismiss from "../../../actions/modalDismiss";
import {connect} from 'react-redux'
import ConfigurationTable from './ConfigurationTable';
import languages from "../../../language/languages";
import esCO from "antd/es/locale/es_ES";
import enUS from "antd/es/locale/en_US";

class AdminConfigurations extends React.Component {

  state = {
    kind: 'configuration'
  };

  componentDidMount() {
    this.props.getConfiguration();
  }

  handleChange = value => {
    this.setState({kind: value})
  };

  updateConfiguration=(form)=>
  {
      this.props.setConfigurationParam(form,this.dismiss);
  };

  dismiss=()=>
  {
      this.props.modalDismiss();
      this.props.getConfiguration();
  };


  handleRender = () => {
    if (this.state.kind === 'configuration') {
        return (
            <ConfigProvider locale={this.props.language==='es'?esCO:enUS}>
            <ConfigurationTable language={this.props.language} modalShow={this.props.modalShow} setConfigurationParam={this.updateConfiguration} dataSource={this.props.adminConfiguration}/>
            </ConfigProvider>
        );
    } else
        return null;
  };

  render() {
    return (
        <div>
          <Select defaultValue={this.state.kind} onChange={this.handleChange}>
            <Select.Option value="configuration">{languages[this.props.language].config_tab}</Select.Option>
          </Select>
          {this.handleRender()}
        </div>
    );
  }
}

const mapStateToProps = state => {
    return {
    language: state.auth.language,
    adminConfiguration: state.system.configuration
  };
};

export default connect(
    mapStateToProps,
    {
      modalShow,
        modalDismiss,
      getConfiguration,
      setConfigurationParam
    })(AdminConfigurations);